import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const ITEMS = [
  { q: "Comment passer une commande ?", a: "Ajoutez vos articles au panier puis validez via le tunnel de commande, ou contactez-nous directement sur WhatsApp pour un accompagnement personnalisé." },
  { q: "Quels sont les délais de livraison ?", a: "En Guadeloupe continentale, les articles en stock sont livrés sous 2 à 5 jours ouvrés." },
  { q: "Comment connaître ma taille ?", a: "Consultez notre Guide des tailles détaillé. En cas de doute, écrivez-nous sur WhatsApp, nous vous conseillons avec plaisir." },
  { q: "Puis-je retourner un article ?", a: "Oui, sous 7 jours après réception, dans son état d'origine. Les articles d'hygiène (lingerie, maillots) ne sont pas retournables." },
  { q: "Comment organiser une vente privée ?", a: "Rendez-vous sur la page Ventes Privées et remplissez le formulaire, ou contactez Esther sur WhatsApp." },
  { q: "Quels sont les modes de paiement ?", a: "Paiement à la livraison et règlement via WhatsApp. Le paiement CB et PayPal sera bientôt disponible." },
  { q: "Livrez-vous à Marie-Galante, Les Saintes, La Désirade ?", a: "Oui ! Nous livrons dans toutes les îles de Guadeloupe, avec un délai légèrement plus long." },
  { q: "Comment suivre ma commande ?", a: "Vous recevez un email de confirmation, puis nous vous tenons informée par WhatsApp jusqu'à la livraison." },
  { q: "Les produits sont-ils de bonne qualité ?", a: "Chaque article est sélectionné avec soin par Esther pour son style, son confort et sa durabilité." },
  { q: "Comment contacter le service client ?", a: "Par WhatsApp (le plus rapide), par email ou via Instagram. Nous sommes disponibles du lundi au samedi, 9h-19h." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <div className="bg-noir text-center py-16 px-6 grain relative">
        <h1 className="font-display text-4xl md:text-6xl text-white relative">Questions Fréquentes</h1>
        <p className="font-serif-el italic text-dore text-lg mt-2 relative">Tout ce qu'il faut savoir</p>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-14">
        <Accordion type="single" collapsible className="w-full">
          {ITEMS.map((it, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-dore/20">
              <AccordionTrigger className="text-left font-medium text-encre hover:text-dore hover:no-underline" data-testid={`faq-${i}`}>{it.q}</AccordionTrigger>
              <AccordionContent className="text-ardoise">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
